<template>
  <section class="basic-stats statistics">
    <Breadcrumbs
      :breadcrumbs="[
        { title: $t('menu.statistics'), disabled: true },
        { title: $t('menu.statistics'), disabled: true }
      ]">
    </Breadcrumbs>

    <form class="evollu-form row mb-3">
      <div class="col-12 col-sm-4">
        <label class="form-label">{{$t('statistics.select_entity')}}:</label>
        <multiselect
          id="entities-multiselect"
          v-model="filters.entity"
          :options="entityOptions"
          track-by="id"
          :custom-label="formatedEntityLabel"
          :placeholder="!entityOptions.length ? $t('statistics.no_entities') : $t('statistics.totalValues')"
          :allow-empty="false"
          :multiple="false"
          :searchable="true"
          :disabled="entityOptions.length < 2"
        >
          <span slot="noResult">{{$t('patients.noResults')}}</span>
          <template slot="clear" slot-scope="props" v-if="entityOptions.length > 1 && filters.entity !== null">
            <div id="entities-multiselect-clear" class="multiselect__clear" @mousedown.prevent.stop="filters.entity = null"></div>
          </template>
        </multiselect>
      </div>

      <div class="col-12 col-sm-4">
        <RangeDatePicker
          id="range-date-picker"
          :label="`${$t('statistics.date_interval')}:`"
          v-model="filters.dateRange"
          placeholder="---"
          :clearable="false"
          :disabled="isLoading"
        >
        </RangeDatePicker>
      </div>
    </form>

    <div v-show="!isLoading" class="leads-stats-content">
      <div class="row">
        <div class="col-md-6 col-xl-3">
          <va-card>
            <div class="info-widget-inner">
              <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ counterEntries }}
                  </div>
                  <div class="stats-title">{{$t('statistics.balcony_registers')}}</div>
                </div>
            </div>
          </va-card>
        </div>

        <div class="col-md-6 col-xl-3">
          <va-card>
            <div class="info-widget-inner">
              <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ kioskEntries }}
                  </div>
                  <div class="stats-title">{{$t('statistics.kiosk_registers')}}</div>
                </div>
            </div>
          </va-card>
        </div>

        <div class="col-md-6 col-xl-3">
          <va-card>
            <div class="info-widget-inner">
              <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{ contactsCount }}
                  </div>
                  <div class="stats-title">{{$t('statistics.contacts_made')}}</div>
                </div>
            </div>
          </va-card>
        </div>

        <div class="col-md-6 col-xl-3">
          <va-card>
            <div class="info-widget-inner">
              <div class="stats">
                  <div class="stats-number">
                    <i class="text-primary stats-icon"></i>
                    {{buysCount}}
                  </div>
                  <div class="stats-title">{{$t('statistics.consultations')}}</div>
                </div>
            </div>
          </va-card>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <va-card class="chart-widget">
            <va-chart :data="counterKioskData" type="donut"></va-chart>
          </va-card>
        </div>

        <div class="col-md-6">
          <va-card class="chart-widget">
            <va-chart :data="kiosksData" type="donut"></va-chart>
          </va-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { StatisticsService } from '@/api/LeadsService'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import { BASIC_STATS } from '@/local-storage/LocalStorageKeys'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'

export default {
  components: {
    Breadcrumbs,
    Multiselect,
    RangeDatePicker
  },
  mixins: [
    MultiselectLabelFormatter
  ],
  data () {
    return {
      isLoading: false,
      dataset: {},
      totalValues: null,
      filters: {
        entity: null,
        dateRange: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD')
        },
        dateType: 'created_at'
      }
    }
  },
  methods: {
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(BASIC_STATS)
        if (state !== null) {
          this.filters = {
            ...this.fitlers,
            ...state
          }
        }
        resolve()
      })
    },
    loadBaseData () {
      this.isLoading = true

      StatisticsService.getBasicStats(this.requestParams)
        .then(originalData => this.createDataset(originalData))
        .catch((error) => {
          console.log(error)
          this.showToast(this.$t('statistics.something_went_wrong'), this.$store.state.errorToastOptions)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    createDataset: function (data) {
      this.dataset = {}
      this.totalValues = null

      if (data.length) {
        this.totalValues = this.createDatasetEntry()
        let keys = Object.keys(this.totalValues)

        data
          .sort((a, b) => a.id - b.id)
          .forEach(element => {
            keys.forEach(key => {
              this.totalValues[key] += element[key]
            })
            this.dataset[element.id] = this.createDatasetEntry(element)
          })
      }
    },
    createDatasetEntry: function (data = {}) {
      return {
        counter: 0,
        kiosk: 0,
        contacts: 0,
        appointments: 0,
        questionnaires: 0,
        ht: 0,
        ht_no_loss: 0,
        ...data
      }
    },
    getFullEntityById: function (id) {
      return this.fullEntities.find(e => e.id === id)
    },
  },
  computed: {
    audiologyService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    fullEntities: function () {
      return this.audiologyService ? this.audiologyService.entities : []
    },
    requestParams: function () {
      return {
        from: this.filters.dateRange.start,
        until: this.filters.dateRange.end,
      }
    },
    entityOptions: function () {
      return Object.values(this.dataset)
        .map(element => {
          let entity = this.getFullEntityById(element.id)
          return {
            id: element.id,
            name: element.name,
            cities: entity ? entity.cities : []
          }
        })
    },
    stats: function () {
      if (this.dataset) {
        if (this.filters.entity) {
          return this.dataset[this.filters.entity.id]
        } else {
          return this.totalValues
        }
      }
      return null
    },
    baseCounterValues: function () {
      if (this.stats) {
        return [
          this.stats.counter,
          this.stats.kiosk
        ]
      } else {
        return [0, 0]
      }
    },
    baseKiosksValues: function () {
      if (this.stats) {
        return [
          this.stats.kiosk - this.stats.questionnaires,
          this.stats.questionnaires - this.stats.ht,
          this.stats.ht_no_loss,
          this.stats.ht - this.stats.ht_no_loss
        ]
      } else {
        return [0, 0, 0, 0]
      }
    },
    counterKioskData: function () {
      return {
        labels: [
          this.$t('statistics.graph_label_counter'),
          this.$t('statistics.graph_label_kiosk')
        ],
        datasets: [{
          data: this.baseCounterValues,
          backgroundColor: [
            '#b3bfbf',
            '#5dceb3'
          ]
        }]
      }
    },
    kiosksData () {
      return {
        labels: [
          this.$t('statistics.graph_label_contact_requested'),
          this.$t('statistics.graph_label_questionary'),
          this.$t('statistics.graph_label_test_without_hearing_loss'),
          this.$t('statistics.graph_label_test_with_hearing_loss')
        ],
        datasets: [{
          data: this.baseKiosksValues,
          backgroundColor: [
            '#5dceb3',
            '#ffc000',
            '#a49d97',
            '#ea4e4e'
          ]
        }]
      }
    },
    counterEntries: function () {
      return this.stats ? this.stats.counter : 0
    },
    kioskEntries: function () {
      return this.stats ? this.stats.kiosk : 0
    },
    contactsCount: function () {
      return this.stats ? this.stats.contacts : 0
    },
    buysCount: function () {
      return this.stats ? this.stats.appointments : 0
    }
  },
  watch: {
    entityOptions: {
      handler: function (options) {
        if (options.length === 1) {
          this.filters.entity = options[0]
        } else if (this.filters.entity && !options.some(option => option.id === this.filters.entity.id)) {
          this.filters.entity = null
        }
      },
      immediate: true
    },
    filters: {
      handler: function () {
        LocalStorageHelper.set(BASIC_STATS, this.filters)
      },
      deep: true
    },
    requestParams: function (value) {
      this.loadBaseData()
    }
  },
  mounted () {
    this.loadLocalStorage()
      .then(() => {
        this.loadBaseData()
      })
  }
}
</script>

<style lang="scss">

.leads-stats-content {
  .info-widget-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    min-height: 100px !important;

    &.has-chart {
      justify-content: space-between;
    }

    .stats {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      min-height: 100px;
    }
  }
}

.stats-number {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 2.625rem;
  margin-bottom: 0.5rem;

  .stats-icon {
    font-size: 1.5625rem;
    position: absolute;
    top: 0.625rem;
    left: -1.25rem;

    &.icon-wide {
      left: -1.875rem;
    }
  }
}

</style>
